import {useScopeQuery} from "@/core/store/scopeQuery";
import {useTime} from "@/core/store/time";
import {arrayIndex} from "@/core/util/arrayIndex";
import {isTimeInSchedule} from "@/core/util/date/schedule";
import {Feature} from "@/gql/gen";
import {defineStore, storeToRefs} from "pinia";
import {computed, ref} from "vue";

const STORE_NAME = "feature";

export const useFeatureStore = defineStore(STORE_NAME, () => {
    const {registerScopeQuery} = useScopeQuery();
    const timeStore = useTime()

    const {timestampIntervalMinuteDate} = storeToRefs(timeStore)

    const isFeatureActive = (feature: Feature) => {
        if (!feature.ACTIVE || !feature.AVAILABLE.STATUS)
            return false
        if (feature.PROPERTIES.SCHEDULE_ENABLE && feature.PROPERTIES.SCHEDULE) {
            // SCHEDULE должен быть объектом вида { "mon": ["09:00-18:00"], ... }
            const schedule = feature.PROPERTIES.SCHEDULE;
            // Проверяем, что schedule - это объект с массивами строк
            if (typeof schedule === 'object' && schedule !== null) {
                // Проверяем, что значения - это массивы строк
                const isValidSchedule = Object.values(schedule).every(
                    (value) => Array.isArray(value) && value.every((item) => typeof item === 'string')
                );
                if (isValidSchedule) {
                    return isTimeInSchedule(schedule as Record<string, string[]>, timestampIntervalMinuteDate.value)
                }
            }
            // Если формат некорректный, считаем feature активной
            return true
        }
        return true
    }

    // State
    const featuresState = ref<Feature[]>([]);

    const features = computed(() => {
        return featuresState.value.map((item) => ({
            ...item,
            ACTIVE_COMPUTED: isFeatureActive(item)
        }))
    })

    const featuresActive = computed(() => {
        return features.value.filter((item) => item.ACTIVE_COMPUTED)
    })

    const featuresActiveByCode = computed(() => {
        return arrayIndex(featuresActive.value, 'CODE')
    })

    const featuresActiveById = computed(() => {
        return arrayIndex(featuresActive.value, 'ID')
    })

    registerScopeQuery(
        STORE_NAME,
        "app",
        {
            feature_list: {
                __fragment: "FeatureFields",
            },
        },
        (data) => {
            if (data.feature_list) {
                featuresState.value = data.feature_list
            }
        }
    );

    return {
        featuresState,
        features,
        featuresActive,
        featuresActiveByCode,
        featuresActiveById
    }
});
